import { render, staticRenderFns } from "./form-deposit-topup.vue?vue&type=template&id=851b537c&"
import script from "./form-deposit-topup.vue?vue&type=script&lang=js&"
export * from "./form-deposit-topup.vue?vue&type=script&lang=js&"
import style0 from "./form-deposit-topup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports